import { render, staticRenderFns } from "./CollectionListView.vue?vue&type=template&id=75e487c0"
import script from "./CollectionListView.vue?vue&type=script&lang=js"
export * from "./CollectionListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports